import { SR_API_ACTION_LEASING_MANAGER_GET_BY_LISTING_ID } from 'api/actionTypes';

export default async function getList({ state, apiClient }, { listingId }) {
  const statePath = ['leasingManagers', 'byListingId', listingId];

  if (state.get(statePath)) {
    return state.get(statePath);
  }

  await apiClient.postWithState({
    action: SR_API_ACTION_LEASING_MANAGER_GET_BY_LISTING_ID,
    state: state,
    payload: {
      listingId: listingId,
    },
    onSuccess(leasingManagers) {
      state.set(statePath, leasingManagers);
    },
  });
}
